<div class="relative w-full">
  <div class="p-2 my-auto w-full">
    <i
      (click)="back()"
      class="material-icons md:hidden text-[16px] cursor-pointer absolute top-3 left-4"
      >arrow_back_ios</i
    >
    @if (!resetPasswordData) {
    <form
      class="w-full md:w-[450px] mt-[10%] mx-auto px-2"
      [formGroup]="forgotPasswordForm"
    >
      <div class="flex justify-center w-full">
        <img
          class="w-[120px] h-[90px]"
          src="assets/nsclogo.png"
          alt="nsc logo"
        />
      </div>
      <h2 class="!text-[16px] !font-[500] text-center text-gray-800 mb-0">
        Reset Password
      </h2>
      <div class="mb-6 flex flex-col gap-6">
        <app-generic-input-field
          id="email"
          label="Email"
          placeholder="Enter your registered email"
          [control]="fForgot['email']"
        ></app-generic-input-field>
      </div>

      <div class="flex flex-col !w-full">
        <app-generic-button
          (buttonClick)="forgotPassword()"
          buttonText="Submit"
        ></app-generic-button>
      </div>
    </form>
    } @else if (resetPasswordData) {
    <form
      class="w-full md:w-[450px] mx-auto px-2 mt-4"
      [formGroup]="resetPasswordForm"
    >
      <h2 class="!text-[16px] !font-[500] text-center textmode mb-0">
        Enter New Password
      </h2>
      <div class="mb-6 flex flex-col gap-6">
        <app-generic-input-field
          id="password"
          label="New Password"
          type="password"
          placeholder="New password"
          [control]="fReset['password']"
          [showPasswordEye]="true"
        ></app-generic-input-field>
        <app-generic-input-field
          id="cPassword"
          label="Confirm password"
          type="password"
          placeholder="Confirm password"
          [control]="fReset['cPassword']"
          [showPasswordEye]="true"
        ></app-generic-input-field>
      </div>

      <div class="items-center w-full">
        <app-generic-button
          btnClass="bg-[#2B547E] !py-3  px-4"
          buttonText="Change Password"
          type="button"
          (click)="resetPassword()"
        >
        </app-generic-button>
      </div>
    </form>
    }

    <div class="justify-center flex mt-6">
      <a
        (click)="back()"
        class="w-auto rounded-sm text-[16px] text-red-700 cursor-pointer"
        >Back</a
      >
    </div>
  </div>
</div>
